import React from 'react';
import ChamberList from './Chamber';

const DiagnosticCenters = () => (
  <div className="diagnostic-centers-container">
    {/* <h1>Diagnostic Centers</h1> */}
    <ChamberList category="Diagnostic" />
  </div>
);

export default DiagnosticCenters;
